import { BalanceData, GearItem, GearTarget, RARITY_IDS, primaryValue } from "@highmarch/domain";
import { icon } from "../iconsKit";
import { gearIconUrl } from "../portraits";
import { RARITY_LABEL, fmtStat, pct } from "../gearUi";
import { WellOpts, tagHtml, wellHtml } from "../components";

/**
 * A gear item's well and fact block, shared by the Market (Sell, Black Market) and the Shops sheet's Merchant gear
 * confirm. Its own module so the Shops sheet needn't import the Market sheet, which opens the Shops sheet.
 */

/** The item's painted medallion in its rarity well (design system v2). */
export function gearWellHtml(B: BalanceData, it: GearItem, size: WellOpts["size"] = "md"): string {
  return wellHtml({ art: gearIconUrl(B.gear.slots[it.slot].id, RARITY_IDS[it.rarity]), rarity: it.rarity, size });
}

/** Name (in rarity ink), primary, affixes and the Mythic effect: the same facts the Armoury card leads with. */
export function itemBlockHtml(B: BalanceData, it: GearItem, withWell = true): string {
  const slot = B.gear.slots[it.slot];
  const affixes = it.affixes.map((a) => tagHtml("info", `${pct(a.value)} ${fmtStat(a.stat)}`)).join("");
  const mythic = it.mythicEffect >= 0 ? `<div class="myth">${icon("star", 13)} <b>${B.gear.mythicEffects[it.mythicEffect].name}:</b> ${B.gear.mythicEffects[it.mythicEffect].description}</div>` : "";
  return `<div class="mitem">${withWell ? gearWellHtml(B, it, "lg") : ""}<div class="mt"><b class="disp ri-${RARITY_IDS[it.rarity]}">${RARITY_LABEL[it.rarity]} ${slot.name}</b>
    <small>${slot.target === GearTarget.Tower ? "Tower" : "Fortress"} slot · Lv ${it.level}</small><span class="prim">${pct(primaryValue(B, it))} ${fmtStat(it.primaryStat)}</span></div></div>
    ${affixes ? `<div class="chips">${affixes}</div>` : ""}${mythic}`;
}
